import React from 'react';
import PropTypes from 'prop-types';
import {
    Grid, Box, Typography
} from '@mui/material';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import SkeletonLoader from '../loader/SkeletonLoader';
import GiftCardDeliveryOptionCarousel from './GiftCardDeliveryOptionCarousel';
import { cardDeliveryTypeOptionsList } from './CardDeliveryTypeOptionsList';

const GiftCardDeliveryTypeOptions = ({
    intl,
    giftCardDeliveryType,
    faceplatesCount,
    isLoading
}) => {
    const numberOfOptionsToShow = (faceplatesCount === 1) ? 4 : 3;
    const sortedCardDeliveryTypeOptionsList = cardDeliveryTypeOptionsList(intl, giftCardDeliveryType);

    return (
        <>
            <Grid container alignItems='stretch'>
                <Grid item xs={12}>
                    {}
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Grid
                            container
                            className={classNames('gift-card-delivery-type-options-wrapper',
                                { 'right-section': faceplatesCount === 1 })}
                            gap={2}
                        >
                            {sortedCardDeliveryTypeOptionsList.slice(0, numberOfOptionsToShow).map(item => (
                                <Grid
                                    key={`${item}`}
                                    item
                                    xs={12}
                                    sm={(faceplatesCount === 1) ? 5.3 : 3.8}
                                    md={(faceplatesCount === 1) ? 5.8 : 3.8}
                                >

                                    <SkeletonLoader
                                        isLoading={isLoading}
                                        skeletonProps={{
                                            animation: 'wave',
                                            variant: 'rectangular',
                                            className: 'skeletonclass',
                                            height: 56
                                        }}
                                    >
                                        <Box className='gift-card-delivery-type-options'>
                                            <span className='delivery-type-options-icon'>
                                                {item.icon}
                                            </span>
                                            <Typography variant="body1" className='delivery-type-options-text'>
                                                {item.text}
                                            </Typography>
                                        </Box>
                                    </SkeletonLoader>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    {}
                    <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                        <GiftCardDeliveryOptionCarousel
                            cardDeliveryTypeOptionsList={sortedCardDeliveryTypeOptionsList}
                            isLoading={isLoading}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

GiftCardDeliveryTypeOptions.defaultProps = {
    faceplatesCount: null
};

GiftCardDeliveryTypeOptions.propTypes = {
    intl: intlShape.isRequired,
    giftCardDeliveryType: PropTypes.string.isRequired,
    faceplatesCount: PropTypes.number,
    isLoading: PropTypes.bool.isRequired
};

export default injectIntl(GiftCardDeliveryTypeOptions);
